if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.imageObserver?.disconnect();
        super.hide();
      }

      disconnectedCallback() {
        this.imageObserver?.disconnect();
      }

      loadImage(image) {
        if (!image?.hasAttribute('data-pb-modal-src')) return;
        // Set responsive candidates before the fallback to avoid a second request.
        image.loading = 'eager';
        if (image.dataset.pbModalSrcset) image.srcset = image.dataset.pbModalSrcset;
        image.src = image.dataset.pbModalSrc;
        image.removeAttribute('data-pb-modal-src');
        image.removeAttribute('data-pb-modal-srcset');
        this.imageObserver?.unobserve(image);
      }

      loadMediaImages(media) {
        if (media.matches('img')) this.loadImage(media);
        media.querySelectorAll('img[data-pb-modal-src]').forEach((image) => this.loadImage(image));
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.imageObserver?.disconnect();
        const images = this.querySelectorAll('img[data-pb-modal-src]');
        if ('IntersectionObserver' in window) {
          this.imageObserver = new IntersectionObserver((entries) => {
            if (!this.hasAttribute('open')) return;
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.loadImage(entry.target);
            });
          }, { root: this.querySelector('[role="document"]'), rootMargin: '200px' });
          images.forEach((image) => this.imageObserver.observe(image));
        } else {
          // Old-browser fallback is still deferred until the modal is opened.
          images.forEach((image) => this.loadImage(image));
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`) || this.querySelector('[data-media-id]');
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.loadMediaImages(activeMedia);
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
